import { ApiProtectedWS as http } from "../api/axios";
import { baseURL } from "../util/Constants";

class infoAzureProjectService {
  getProjects(organization: string, token: string) {
    const response = http.get(
      `${baseURL.interoperabilityApi.AzureProjects}/projects?organization=${organization}&token=${token}`
    );
    return response;
  }

  /*getProjectDetails(organization: string, token: string, projectId: string) {
    const response = http.get(
      `${baseURL.interoperabilityApi.AzureProjects}/project-details?organization=${organization}&token=${token}&projectId=${projectId}`
    );
    return response;
  }*/

  // getProjectBoards(organization: string, token: string, projectId: string) {
  //   const response = http.get(
  //     `${baseURL.interoperabilityApi.AzureProjects}/project-boards?organization=${organization}&token=${token}&projectId=${projectId}`
  //   );
  //   return response;
  // }

  getBoardSprints(organization: string, token: string, projectId: string) {
    const response = http.get(
      `${baseURL.interoperabilityApi.AzureProjects}/board-sprints?organization=${organization}&token=${token}&projectId=${projectId}`
    );
    return response;
  }

  getProjectTasks(organization: string, token: string, projectId: string) {
    const response = http.post(
      `${baseURL.interoperabilityApi.AzureProjects}/project-tasks?organization=${organization}&token=${token}&projectId=${projectId}`
    );
    return response;
  }
  
  /*getParents(organization: string, token: string, projectId: string) {
    const response = http.post(
      `${baseURL.interoperabilityApi.AzureProjects}/project-Parents?organization=${organization}&token=${token}&projectId=${projectId}`
    );
    return response;
  }*/
  
  /*async getWorkItemParents(organization: string, token: string, projectId: string) {
    try {
      // Paso 1: Obtener los IDs de los work items
      const response = await this.getProjectTasks(organization, token, projectId);
      const obj = JSON.parse(JSON.stringify(response.data));
      let ids: number[] = [];
      if (obj.workItems && obj.workItems.length > 0) {
        obj.workItems.forEach((item: any) => ids.push(item.id));
      } else {
        return { message: "AZURE T: No hay tareas en este proyecto.", details: [], parents: [] };
      }

    
      const relationfields = [
        "System.Id",
        "System.Title",
        "System.WorkItemType",
        "System.Parent"
      ];
      const parentsResponse = await http.post(
        `${baseURL.interoperabilityApi.AzureProjects}/workitems-parents?organization=${organization}&token=${token}`,
        {
          ids: ids,
          relationfields: relationfields
        }
      );

      const parents = parentsResponse.data;
      return { obj, parents };
    } catch (error) {
      console.error('Error al obtener las relaciones padre-hijo de los work items:', error);
      throw error;
    }
  }*/



  async getWorkItemDetails(organization: string, token: string, projectId: string) {
    try {
      // Paso 2: Obtener los detalles de los work items usando los IDs obtenidos
      const detailsResponse = await http.post(
        `${baseURL.interoperabilityApi.AzureProjects}/workitems-batch?organization=${organization}&token=${token}&projectId=${projectId}`
      );

      const details = detailsResponse.data;
      // console.log(obj,details);
      /*console.log('Detalles de work items recibidos:', details);
      details.value.forEach((item: any) => {
          if (!item.fullTitle) {
              console.warn(`El elemento con ID ${item.id} no tiene fullTitle`);
          } else {
              console.log(`Elemento con ID ${item.id} tiene fullTitle: ${item.fullTitle}`);
          }
      });*/

    return { details };
    } catch (error) {
      console.error('Error al obtener los detalles de los work items:', error);
      throw error;
    }
  }

  getConnectionInfo() {
    return http?.get(`${baseURL.interoperabilityApi.AzureProjects}/connection-info`);
  }

  getWorkitemsStates(organization: string, token: string, projectId: string, type: string) {
      return http?.get(
          `${baseURL.interoperabilityApi.AzureProjects}/workitem-states?organization=${organization}&token=${token}&projectId=${projectId}&type=${type}`
      );
  }

  updateWorkitemState(organization: string, token: string, projectId: string, data: any) {
      return http?.patch(
          `${baseURL.interoperabilityApi.AzureProjects}/update-workitem-state?organization=${organization}&token=${token}&projectId=${projectId}`,
          data
      );
  }
  
}
export default new infoAzureProjectService();
